import { render, staticRenderFns } from "./time-format-editor.vue?vue&type=template&id=48147b42&scoped=true&"
import script from "./time-format-editor.vue?vue&type=script&lang=js&"
export * from "./time-format-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48147b42",
  null
  
)

export default component.exports